import { render, staticRenderFns } from "./RatingElement.vue?vue&type=template&id=04dbc75c&scoped=true&"
import script from "./RatingElement.vue?vue&type=script&lang=ts&"
export * from "./RatingElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dbc75c",
  null
  
)

export default component.exports